import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';

import { Toast } from '@stylehaven/components';
import { ToastState } from '../shared-state.interface';
import { ToastAction, ToastActionTypes } from './toast.actions';

export const toastAdapter: EntityAdapter<Toast> = createEntityAdapter<Toast>();
export const emptyToastState: ToastState = toastAdapter.getInitialState();

export function toastReducer(state = emptyToastState, action: Action): ToastState {
    const toastAction: ToastAction = action as ToastAction;
    switch (toastAction.type) {
        case ToastActionTypes.AddToast:
            return toastAdapter.addOne(toastAction.toast, state);

        case ToastActionTypes.UpsertToast:
            return toastAdapter.upsertOne(toastAction.toast, state);

        case ToastActionTypes.DeleteToast:
            return toastAdapter.removeOne(toastAction.id, state);

        case ToastActionTypes.UpdateToast:
            return toastAdapter.updateOne({ id: toastAction.id, changes: toastAction.changes }, state);

        case ToastActionTypes.Clear:
            return toastAdapter.removeAll(state);

        default:
            return state;
    }
}
